import { render, staticRenderFns } from "./RecentActivityTable.vue?vue&type=template&id=87673d52&scoped=true"
import script from "./RecentActivityTable.vue?vue&type=script&lang=js"
export * from "./RecentActivityTable.vue?vue&type=script&lang=js"
import style0 from "./RecentActivityTable.vue?vue&type=style&index=0&id=87673d52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87673d52",
  null
  
)

export default component.exports